import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M8.634 15.122a2.439 2.439 0 1 1 0 4.878 2.439 2.439 0 0 1 0-4.878m6.828 0a2.44 2.44 0 1 1 0 4.879 2.44 2.44 0 0 1 0-4.879M4.999 0a1 1 0 0 1 .982.813L6.78 5h11.357a1 1 0 0 1 .986 1.164l-1.13 6.781a1 1 0 0 1-.986.835H6.993a1 1 0 0 1-.986-.835L4.683 5h.06l-.571-3H0V0z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "shoppingcart"}) } }